import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutus-container">
      <div className="aboutus-header">
        <h1>About Us</h1>
        <p>Your trusted partner in Satta Wala insights & updates</p>
      </div>

      <div className="aboutus-content">
        <section className="aboutus-section">
          <h2>About Satta Wala Online</h2>
          <p>
            People probably query about <strong>Satta Wala Online</strong>. How can
            we play Satta games online, try our luck, and become rich in minimum
            time? People love to talk about <strong>Satta Games</strong> and love
            to find out about them online. Satta games are like a trend in India
            and many people are involved in them.  
          </p>
          <p>
            At <strong>Satta Wala</strong>, we do not host or allow Satta Games
            to be played on our website. But for our users, we share results and
            information to help them. Last year, the popularity of Satta Wala has
            been increasing day by day.
          </p>
        </section>

        <section className="aboutus-section">
          <h2>Why People Love Satta Wala</h2>
          <p>
            Do you know why people love the <strong>Satta Wala Game</strong>? Because
            Satta gives you money like a magician. And who doesn’t love money? Everyone
            wants money. With no efforts, you just try your luck in Satta Wala and earn
            money in some time.  
          </p>
          <p>
            After trying your luck in Satta Wala, you need to find a genuine online
            website for getting results. No one wants to wait because no one has time
            and everyone wants to save their time. Our website is the best solution —
            we provide the <strong>fastest Satta Wala live results online</strong>.
          </p>
        </section>

        <section className="aboutus-section">
          <h2>Fast Results & Records</h2>
          <p>
            Our website is updated on a regular basis. If you want last year’s specific
            month and day <strong>Satta Wala result</strong>, you just need to select
            the month, date, and year — and within a minute you will get your result
            online.  
          </p>
          <p>
            We also provide record charts such as the complete{" "}
            <strong>Satta Wala December 2021 Record Chart</strong> and previous years’
            results.
          </p>
        </section>

        <section className="aboutus-section">
          <h2>How to Find Satta Wala Results</h2>
          <ul>
            <li>
              First, search for <strong>Satta Wala Games Online</strong> in any search
              engine. A list of websites will appear giving you a chance to check
              results.
            </li>
            <li>
              Next, find a <strong>Satta Wala live result website</strong>. Our website
              provides the fastest and most genuine results online.
            </li>
          </ul>
        </section>

        <section className="aboutus-section">
          <h2>Why Choose Us?</h2>
          <ul>
            <li> Oldest and trusted platform</li>
            <li> Genuine & fastest Satta Wala results</li>
            <li> Daily and monthly record updates</li>
            <li> Easy-to-use interface</li>
            <li> Contact support available — you can WhatsApp us directly for any query</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
